import { ThemeProvider } from "styled-components"

import { theme } from "./theme"

// eslint-disable-next-line react/prop-types
export const LegacyThemeProvider: React.FC = ({ children }) => {
    return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
